import { Inject, Injectable } from '@angular/core';
import { WINDOW } from '@core/tokens';

const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const ID_TOKEN = 'id_token';
const PKCE_VERIFIER = 'PKCE_verifier';
const NONCE = 'nonce';
const LOGIN_HINT_EMAIL = 'login_hint_email';

const KEYS = [ACCESS_TOKEN, REFRESH_TOKEN, ID_TOKEN, PKCE_VERIFIER, NONCE, LOGIN_HINT_EMAIL];

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
    @Inject(WINDOW) private _window: Window
  ) { }

  private get _storage(): Storage {
    return this._window.localStorage;
  }

  get accessToken(): string {
    return this._storage.getItem(ACCESS_TOKEN) || '';
  }

  get refreshToken(): string {
    return this._storage.getItem(REFRESH_TOKEN) || '';
  }

  get idToken(): string {
    return this._storage.getItem(ID_TOKEN) || '';
  }

  get pkceVerifier(): string {
    return this._storage.getItem(PKCE_VERIFIER) || '';
  }

  get nonce(): string {
    return this._storage.getItem(NONCE) || '';
  }

  get loginHintEmail(): string {
    return this._storage.getItem(LOGIN_HINT_EMAIL) || '';
  }

  get hasToken(): boolean {
    return !!this.accessToken && !!this.refreshToken && !!this.idToken;
  }

  setAccessToken(value: string): void {
    this._storage.setItem(ACCESS_TOKEN, value);
  }

  setRefreshToken(value: string): void {
    this._storage.setItem(REFRESH_TOKEN, value);
  }

  setIdToken(value: string): void {
    this._storage.setItem(ID_TOKEN, value);
  }

  setPkceVerifier(value: string): void {
    this._storage.setItem(PKCE_VERIFIER, value);
  }

  setNonce(value: string): void {
    this._storage.setItem(NONCE, value);
  }

  setLoginHintEmail(value: string): void {
    this._storage.setItem(LOGIN_HINT_EMAIL, value);
  }

  clear(): void {
    KEYS.forEach(key => this._storage.removeItem(key));
  }

  /** Removes the transient OIDC keys once the code exchange has consumed them. */
  clearTransient(): void {
    this._storage.removeItem(PKCE_VERIFIER);
    this._storage.removeItem(NONCE);
  }
}
